<template>
  <div class="info">
    <i class="icon info__icon">?</i>
    <span :name="getTooltipName">
      <slot name="tooltip_title"></slot>
    </span>

    <tippy :to="getTooltipName" :arrow="true" :theme="getTooltipTheme">
      <slot></slot>
    </tippy>
  </div>
</template>

<script>
export default {
  name: "InfoTooltip",

  props: {
    tooltipName: {
      type: String,
      required: true,
    },
    tooltipAdditionalTheme: {
      type: String,
      default: "",
    },
  },

  computed: {
    getTooltipName() {
      return `tooltip__${this.tooltipName}__${Math.random()}`;
    },
    getTooltipTheme() {
      return `wf-bp ${this.tooltipAdditionalTheme}`;
    },
  },
};
</script>
